import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Barcode from 'react-barcode';
import BackButton from './BackButton';

const BarcodePrint = () => {
  const { barcode: urlBarcode } = useParams();
  const [barcode, setBarcode] = useState(urlBarcode || ''); // Set initial barcode from URL or empty string
  
  // Update barcode state when the user types in the input field
  const handleInputChange = (e) => {
    setBarcode(e.target.value);
  };

  // Trigger print dialog
  const handlePrint = () => {
    window.print(); // Trigger the print dialog
  };

  return (
    <div className="container py-5">
      {/* Apply no-print to everything except the barcode */}
      <div className="no-print">
        <BackButton></BackButton>
        {/* Instructions Section */}
        <div className="row mb-4">
          <div className="col-12">
            <h2 className="text-center">Print a Barcode</h2>
            <div className="alert alert-info">
              <p><strong>Steps to print:</strong></p>
              <ul>
                <li>Click the <strong>"Print Barcode"</strong> button below.</li>
                <li>In the print dialog, make sure the paper size is set to <strong>4x1 inches</strong>.</li>
                <li>Set margins to <strong>None</strong> in the print settings.</li>
                <li>Ensure the scaling is set to <strong>100%</strong>.</li>
                <li>Click <strong>Print</strong> to print your barcode label.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Barcode Input Section */}
        <div className="row mb-4">
          <div className="col-12 col-md-6 offset-md-3 text-center">
            <label htmlFor="barcodeInput" className="form-label">Enter or Change Barcode</label>
            <input
              id="barcodeInput"
              type="text"
              className="form-control"
              value={barcode}
              onChange={handleInputChange}
              placeholder="Enter barcode here"
            />
          </div>
        </div>

        {/* Print Button */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 text-center">
            <button onClick={handlePrint} className="btn btn-primary mb-4">
              Print Barcode
            </button>
          </div>
        </div>
      </div>

      {/* Barcode Display (this will appear in print) */}
      {barcode && (
        <div className="printable-content">
          <div className="barcode-container">
            <Barcode
              value={barcode}
              options={{
                format: 'CODE128',  // Barcode format
                width: 2,           // Width of the barcode
                height: 100,        // Height of the barcode
                displayValue: true, // Display the barcode value below the barcode
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BarcodePrint;
